import type { ChartDataPoint } from '@gonfalon/dataviz-experimental/types/ChartDataPoint';

/**
 * Calculate total traffic count from chart data.
 * Sums the latest (most recent) cumulative values for all treatments.
 *
 * @param chartData Array of chart data points with timestamps and treatment values
 * @returns Total cumulative traffic count across all treatments
 */
export function calculateTrafficTotal(chartData: ChartDataPoint[]): number {
  if (!chartData.length) {
    return 0;
  }

  // Get the latest data point (last in array, highest timestamp)
  const latestPoint = chartData[chartData.length - 1];

  // Sum all treatment values (exclude 'timestamp' key and non-numeric values)
  return Object.entries(latestPoint)
    .filter(([key]) => key !== 'timestamp')
    .reduce((sum, [, value]) => {
      // Only sum numeric values (treatment traffic counts)
      if (typeof value === 'number') {
        return sum + value;
      }
      return sum;
    }, 0);
}
